<template>
  <div class="bg auth-screen">
    <div class="container pt-80 pb-50">
      <div class="card">
        <div class="card-body">
          <h2 class="card-title">Create a Username</h2>
          <div class="card-description">
            Provide a username and password below that will be used as your new account credentials.
          </div>
          <createUsernamePassword />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import createUsernamePassword from "@/components/auth/create-username-password-component";
export default {
  name: "CreateUsername",
  components: {
    createUsernamePassword
  }
};
</script>
<style lang="scss" src="@/assets/auth-screen.scss"></style>
